/*
 * SkillzSDK-iOS
 *
 * Created by Tj Fallon on 8/8/16.
 *
 * @providesModule RatingModalStyles
 *
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {StyleSheet} from 'react-native';

const {
  btnTextColorOne,
  textColorTertiary,
  fontBold,
  fontSecondary,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  fontRegular,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  centerDialog: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: SkillzStyle.convertToOpacity('#000000', 0.6),
  },

  headerContainer: {
    alignItems: 'center',
    marginHorizontal: 0,
  },

  titleText: {
    textAlign: 'center',
    ...fontSizeH2,
    ...fontBold,
    ...fontSecondary,
  },

  subtitleText: {
    textAlign: 'center',
    ...fontSizeH4,
    ...fontSecondary,
    ...fontRegular,
  },

  instructionsText: {
    textAlign: 'center',
    ...fontSizeH5,
    ...fontSecondary,
    ...fontRegular,
  },

  titleTextAndroid: {
    textAlign: 'center',
    color: 'black',
    ...fontSizeH2,
    ...fontBold,
    ...fontSecondary,
  },

  subtitleTextAndroid: {
    textAlign: 'center',
    color: 'black',
    ...fontSizeH4,
    ...fontSecondary,
    ...fontRegular,
  },

  instructionsTextAndroid: {
    textAlign: 'center',
    color: 'black',
    ...fontSizeH5,
    ...fontSecondary,
    ...fontRegular,
  },

  buttonComponent: {
    height: Sizes.orientation({
      portrait: 45,
      landscape: 40,
    }),
    width: Sizes.orientation({
      portrait: Sizes.dynamic({
        sm: 120,
        lg: 150,
      }),
      landscape: 120,
    }),
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 4,
    marginBottom: -4,
  },

  buttonText: {
    marginHorizontal: 5,
    backgroundColor: 'transparent',
    textAlign: 'center',
    ...fontSizeH3,
    ...btnTextColorOne,
    ...fontSecondary,
  },

  userInputContainer: {
    width: Sizes.dynamic({
      sm: 245,
      lg: 310,
    }),
    marginBottom: Sizes.orientation({
      portrait: 15,
      landscape: 10,
    }),
  },

  starsContainer: {
    flexDirection: 'row',
    paddingTop: Sizes.orientation({
      portrait: 15,
      landscape: 6,
    }),
    height: Sizes.orientation({
      portrait: 45,
      landscape: 40,
    }),
    margin: 4,
    width: 250,
    justifyContent: 'center',
    alignItems: 'center',
  },

  starContainer: {
    width: Sizes.orientation({
      portrait: 45,
      landscape: 40,
    }),
    height: Sizes.orientation({
      portrait: 45,
      landscape: 40,
    }),
    paddingHorizontal: 7,
  },

  containerStyle: {
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
  },

  inputSectionText: {
    flexGrow: 1,
    padding: 6,
    borderColor: SkillzStyle.fullStyles.textColorTertiary.color,
    borderWidth: 1,
    borderRadius: SkillzStyle.fullStyles.viewCornerRadiusPrimary.borderRadius,
    ...fontSizeH4,
    ...textColorTertiary,
  },
});
